const bn = {
  nav: {
    login: 'লগইন',
    bookNow: 'এখনই বুক করুন',
    dashboard: 'ড্যাশবোর্ড',
    back: 'পিছনে',
    home: 'হোম',
  },
  landing: {
    heroTitle1: 'আকাশপথে যাত্রা,',
    heroTitle2: 'এখন সহজ',
    heroSubtitle: 'ভারতের শীর্ষস্থানীয় হেলিকপ্টার চার্টার অ্যাগ্রিগেটর। যাচাইকৃত অপারেটরদের সাথে যুক্ত হন, তাৎক্ষণিক ফ্লাইট বুক করুন।',
    bookYourFlight: 'আপনার ফ্লাইট বুক করুন',
    becomeOperator: 'অপারেটর হন',
    whyChoose: 'কেন AirYatra বেছে নেবেন?',
    verifiedOperators: 'যাচাইকৃত অপারেটর',
    verifiedOperatorsDesc: 'সমস্ত অপারেটর AOC সার্টিফিকেট, বীমা এবং নিরাপত্তা সম্মতি সহ সম্পূর্ণভাবে যাচাইকৃত।',
    bestPrices: 'সেরা মূল্য',
    bestPricesDesc: 'AI-চালিত মূল্য পরামর্শ একাধিক অপারেটরের কাছ থেকে প্রতিযোগিতামূলক কোটেশন নিশ্চিত করে।',
    seamlessBooking: 'সহজ বুকিং',
    seamlessBookingDesc: 'কোটেশন অনুরোধ থেকে ডিজিটাল টিকিট পর্যন্ত, আপনার সম্পূর্ণ যাত্রা এক প্ল্যাটফর্মে পরিচালনা করুন।',
    flightsCompleted: 'সম্পন্ন ফ্লাইট',
    verifiedOperatorsStat: 'যাচাইকৃত অপারেটর',
    safetyRecord: 'নিরাপত্তা রেকর্ড',
    customerRating: 'গ্রাহক রেটিং',
    premiumServices: 'প্রিমিয়াম পরিষেবা',
    elevateExperience: 'আপনার অভিজ্ঞতা উন্নত করুন',
    premiumSubtitle: 'আমাদের প্রিমিয়াম সদস্যপদ এবং কর্পোরেট ভ্রমণ সমাধানের সাথে বিশেষ সুবিধা পান',
    blackDesc: '২০% পর্যন্ত ছাড়, অগ্রাধিকার বুকিং, ডেডিকেটেড পাইলট এবং এক্সক্লুসিভ লাউঞ্জ অ্যাক্সেস সহ প্রিমিয়াম সদস্যপদ।',
    priorityQueue: 'অগ্রাধিকার বুকিং সারি',
    dedicatedManager: 'ডেডিকেটেড রিলেশনশিপ ম্যানেজার',
    freeCancellation: 'বিনামূল্যে বাতিলকরণ',
    exploreMembership: 'সদস্যপদ দেখুন',
    corporateConsole: 'কর্পোরেট কনসোল',
    corporateDesc: 'অনুমোদন ওয়ার্কফ্লো, বাজেট এবং একত্রিত বিলিং সহ এন্টারপ্রাইজের জন্য কেন্দ্রীভূত ভ্রমণ ব্যবস্থাপনা।',
    employeeManagement: 'কর্মচারী ব্যবস্থাপনা',
    budgetControls: 'বাজেট নিয়ন্ত্রণ',
    travelAnalytics: 'ভ্রমণ বিশ্লেষণ',
    corporateRegistration: 'কর্পোরেট নিবন্ধন',
    documentVault: 'ডকুমেন্ট ভল্ট',
    vaultDesc: 'DGCA নথি, বীমা, লাইসেন্সের জন্য সুরক্ষিত এনক্রিপ্টেড স্টোরেজ - মেয়াদ শেষের সতর্কতা এবং সংস্করণ নিয়ন্ত্রণ সহ।',
    encryption: 'AES-256 এনক্রিপশন',
    expiryReminders: 'মেয়াদ শেষের রিমাইন্ডার',
    secureSharing: 'নিরাপদ শেয়ারিং',
    openVault: 'ভল্ট খুলুন',
    loginToAccess: 'অ্যাক্সেসের জন্য লগইন করুন',
    readyTakeOff: 'উড়তে প্রস্তুত?',
    ctaSubtitle: 'আজই আপনার হেলিকপ্টার চার্টার বুক করুন এবং বিমান চলাচলের শ্রেষ্ঠত্ব অনুভব করুন।',
    startBooking: 'বুকিং শুরু করুন',
    footerText: '© 2025 AirYatra. সর্বস্বত্ব সংরক্ষিত। ভারতের শীর্ষস্থানীয় হেলিকপ্টার চার্টার প্ল্যাটফর্ম।',
  },
  booking: {
    title: 'আপনার ফ্লাইট বুক করুন',
    subtitle: 'AirYatra - প্রিমিয়াম এয়ার মোবিলিটি পরিষেবা',
    previous: 'পূর্ববর্তী',
    next: 'পরবর্তী',
    loginPrompt: 'বুকিং অনুসন্ধানের জন্য লগইন করুন',
    loginBtn: 'লগইন',
    steps: {
      passengers: 'যাত্রী',
      booking_type: 'বুকিং ধরন',
      route: 'রুট',
      price_inquiry: 'মূল্য',
    },
  },
  bookingForm: {
    selectAircraftType: 'বিমানের ধরন নির্বাচন করুন',
    maxPassengers: 'সর্বোচ্চ {{count}} জন যাত্রী',
    adultPassengers: 'প্রাপ্তবয়স্ক যাত্রী',
    male: 'পুরুষ',
    female: 'মহিলা',
    totalAdults: 'মোট প্রাপ্তবয়স্ক',
    children: 'শিশু (৪ বছর পর্যন্ত)',
    childrenFree: 'বিনামূল্যে - সর্বোচ্চ ২ শিশু',
    flightType: 'ফ্লাইটের ধরন',
    selectOption: '-- নির্বাচন করুন --',
    bookingFor: 'কার জন্য বুকিং',
    bookingPurpose: 'বুকিংয়ের উদ্দেশ্য',
    selected: 'নির্বাচিত',
    specifyPurpose: 'উদ্দেশ্য উল্লেখ করুন',
    pickupLocation: 'পিকআপ স্থান',
    selectPickupPoint: 'পিকআপ পয়েন্ট নির্বাচন করুন',
    dropLocation: 'ড্রপ স্থান',
    selectDropPoint: 'ড্রপ পয়েন্ট নির্বাচন করুন',
    estimatedDistance: 'আনুমানিক দূরত্ব',
    villageDocsTitle: 'গ্রাম ল্যান্ডিং - নথি প্রয়োজন',
    villageDocsDesc: 'গ্রাম/ব্যক্তিগত জমিতে অবতরণের জন্য কর্তৃপক্ষের কাছ থেকে নিম্নলিখিত নথি নিতে হবে:',
    villageDocsNote: 'বুকিং নিশ্চিত হওয়ার পরে, আপনাকে এই নথিগুলি আপলোড করতে হবে। Admin/Operator যাচাই করার পরেই পাইলট উড়বেন।',
    departureDate: 'যাত্রার তারিখ',
    pickupTime: 'পিকআপ সময়',
    additionalOptions: 'অতিরিক্ত বিকল্প (ঐচ্ছিক)',
    waitingTime: 'অপেক্ষার সময় (মিনিট)',
    waitingTimeNote: 'প্রথম ৩০ মিনিট বিনামূল্যে, তারপর চার্জ প্রযোজ্য',
    nightHalts: 'রাত্রি যাপন',
    nightHaltsNote: 'ক্রু থাকার খরচ অন্তর্ভুক্ত',
    bookingSummary: 'বুকিং সারাংশ',
    aircraftTypeLabel: 'বিমানের ধরন:',
    totalPassengersLabel: 'মোট যাত্রী:',
    adults: 'প্রাপ্তবয়স্ক',
    childrenLabel: 'শিশু',
    flightTypeLabel: 'ফ্লাইটের ধরন:',
    pickupLabel: 'পিকআপ:',
    dropLabel: 'ড্রপ:',
    distanceLabel: 'দূরত্ব:',
    dateTimeLabel: 'তারিখ ও সময়:',
    at: 'সময়',
    villageApprovalTitle: 'গ্রাম ল্যান্ডিং - অ্যাডমিন অনুমোদন প্রয়োজন',
    villageApprovalDesc: 'আপনার অনুসন্ধান অ্যাডমিন অনুমোদনের জন্য জমা দেওয়া হবে। অনুমোদনের পরে পেমেন্ট সক্রিয় হবে।',
    priceBreakdown: 'মূল্য বিবরণ',
    baseFlightCost: 'মূল ফ্লাইট খরচ',
    flightCost: 'ফ্লাইট খরচ',
    positioningCost: 'পজিশনিং খরচ (ডেড-লেগ)',
    roundTripDiscount: 'রাউন্ড ট্রিপ ছাড়',
    operatorGrossCost: 'অপারেটর মোট খরচ',
    additionalCharges: 'অতিরিক্ত চার্জ',
    waitingGroundHolding: 'অপেক্ষা / গ্রাউন্ড হোল্ডিং',
    nightHalt: 'রাত্রি যাপন ({{count}} রাত)',
    crewAccommodation: 'ক্রু থাকা ও খাবার',
    fuelSurcharge: 'জ্বালানি সারচার্জ',
    platformFees: 'প্ল্যাটফর্ম ফি',
    convenienceFee: 'সুবিধা ফি',
    insurance: 'বীমা',
    peakSurge: 'পিক সিজন সার্জ',
    platformCommission: 'প্ল্যাটফর্ম কমিশন',
    included: 'অন্তর্ভুক্ত',
    helipadCharges: 'হেলিপ্যাড ল্যান্ডিং চার্জ',
    totalLandingCharges: 'মোট ল্যান্ডিং চার্জ',
    taxableAmount: 'করযোগ্য পরিমাণ',
    totalGst: 'মোট GST',
    grandTotal: 'সর্বমোট',
    inclusiveTaxes: 'সমস্ত কর সহ',
    operatorReceives: 'অপারেটর পাবেন',
    specialRequirements: 'বিশেষ প্রয়োজনীয়তা (ঐচ্ছিক)',
    specialRequirementsPlaceholder: 'কোনো বিশেষ অনুরোধ বা প্রয়োজনীয়তা...',
    submitting: 'জমা দেওয়া হচ্ছে...',
    submitApproval: 'অনুমোদনের জন্য জমা দিন',
    generateInquiry: 'অনুসন্ধান পাঠান',
    approvalNote: 'গ্রাম ল্যান্ডিংয়ের জন্য অ্যাডমিন অনুমোদন প্রয়োজন।',
    inquiryNote: 'অনুসন্ধানের পরে, অপারেটররা আপনাকে কোটেশন পাঠাবেন।',
    formRestored: 'ফর্ম ডেটা পুনরুদ্ধার করা হয়েছে!',
    selectAircraftError: 'অনুগ্রহ করে বিমানের ধরন নির্বাচন করুন',
    minAdultError: 'কমপক্ষে ১ জন প্রাপ্তবয়স্ক যাত্রী প্রয়োজন',
    maxChildrenError: 'সর্বোচ্চ ২ শিশু অনুমোদিত',
    selectFlightTypeError: 'অনুগ্রহ করে ফ্লাইটের ধরন নির্বাচন করুন',
    selectBookingForError: 'কার জন্য বুকিং তা নির্বাচন করুন',
    selectPurposeError: 'বুকিংয়ের উদ্দেশ্য নির্বাচন করুন',
    selectPickupError: 'পিকআপ স্থান নির্বাচন করুন',
    selectDropError: 'ড্রপ স্থান নির্বাচন করুন',
    selectDateError: 'যাত্রার তারিখ নির্বাচন করুন',
    selectTimeError: 'পিকআপ সময় নির্বাচন করুন',
    priceWaitError: 'মূল্য গণনা হয়নি! অনুগ্রহ করে অপেক্ষা করুন',
    inquirySubmitted: 'অনুসন্ধান জমা হয়েছে! অপারেটররা শীঘ্রই উত্তর দেবেন',
    noteVillageApproval: 'গ্রাম ল্যান্ডিংয়ের জন্য অ্যাডমিন অনুমোদন প্রয়োজন',
    notePriceEngine: 'এভিয়েশন-গ্রেড প্রাইসিং ইঞ্জিন দ্বারা গণনা',
    noteFinalPrice: 'চূড়ান্ত মূল্য অপারেটর দ্বারা নিশ্চিত হবে',
    docCollectorNoc: 'কালেক্টর NOC',
    docFireDept: 'ফায়ার বিভাগের প্রাপ্তিস্বীকার',
    docPoliceStation: 'স্থানীয় থানার প্রাপ্তিস্বীকার',
    docSpDcp: 'SP/DCP প্রাপ্তিস্বীকার',
  },
  options: {
    helicopter: 'হেলিকপ্টার',
    chartered_plane: 'চার্টার্ড বিমান',
    one_hour: '১ ঘণ্টার ফ্লাইট',
    two_hour: '২ ঘণ্টার ফ্লাইট',
    half_day: 'অর্ধ দিন',
    full_day: 'পুরো দিন',
    multi_city: 'মাল্টি-সিটি',
    point_to_point: 'পয়েন্ট-টু-পয়েন্ট',
    self: 'নিজের জন্য',
    friend_family: 'বন্ধু ও পরিবার',
    company: 'কোম্পানি / কর্পোরেট',
    political: 'রাজনৈতিক / VIP',
    other: 'অন্যান্য',
    wedding: 'বিয়ে',
    temple_yatra: 'মন্দির যাত্রা',
    company_tour: 'কর্পোরেট ট্যুর',
    election_tour: 'নির্বাচনী প্রচার',
    medical_emergency: 'মেডিকেল ইমার্জেন্সি',
    film_shooting: 'ফিল্ম শুটিং',
    general_tour: 'সাধারণ ভ্রমণ',
    pilgrimage: 'তীর্থযাত্রা',
    business: 'ব্যবসায়িক মিটিং',
  },
};

export default bn;
